import React, { useContext,useEffect,useState } from 'react';
import { FormContext } from '../FormContext/FormContext';
import { getRequireContractorDetails, isContractorField } from '../FormContext/DetailsContext';
import { Box, Grid } from '@mui/material';
import ThumbnailsGrid from '../Components/ThumbnailsGrid';
import { Heading, Table, TableRow, TableCell, TableBody } from '@lmig/lmds-react';
import { DETAILS, REVIEW } from '../constants';


const Review = () => {
  const [values] = useContext(FormContext);
  const { details, isContractor, uploads } = values;
  const requireContractorDetails = getRequireContractorDetails(values);
  const generalDetailsItems = [];
  const contractorDetailsItems = [];
  const filterFilesByEstimate = uploads.files.filter((file) => file.category === 'estimate');
  const filterFilesByOther = uploads.files.filter((file) => file.category !== 'estimate');
   const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    useEffect(() => {
      const handleResize = () => setWindowWidth(window.innerWidth);
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  
 
  const cardContentStyle = {
  
    maxWidth: '665px',
    display: 'flex',
    padding:'12px  0px',
    justifyContent: 'space-between'
  };

  const styleForLabel = {
    textAlign: 'left',
    fontFamily: '"Roboto",Arial,sans-serif',
    fontWeight: 700,
    fontStyle: 'Bold',
    fontSize: '16px',
    leadingTrim: 'NONE',
    lineHeight: '25.6px',
    letterSpacing: '0%',
    verticalAlign: 'middle'
  };
   const styleForValues = {
    overflow: 'auto', 
    maxWidth: '220px', 
    overflowWrap: 'break-word', 
    textAlign: 'right', 
    fontSize: '16px',
    fontFamily: '"Roboto",Arial,sans-serif',
    fontWeight: 400,
    leadingTrim: 'NONE',
    lineHeight: '25.6px',
    letterSpacing: '0%',
    verticalAlign: 'middle'
  };

  const styleForSeparator = {
   maxWidth: '665px', 
   marginLeft:'0px', 
  border: 'none',
  borderBottom: '1px solid #C0BFC0',
  borderBlockColor: '#C0BFC0 !important'
  };
  const styleHeading = {
   marginTop:'32px', 
   marginBottom:'16px'
  };

  const getDetailsLabel = (name) => {
    const field = DETAILS[name];
    return field.reviewLabel || field.label;
  };

  const getDetailsValue = (name) => {
    const field = details[name];
    switch (name) {
      case 'linesOfCoverage':
        return field.value.join(', ');

      default:
        return field.value;
    }
  };
  const getLabel = (keyName) => {
    if (keyName === 'claimNumber') {
      return 'Claim number';
    }
    if (keyName === 'contactName') {
      return 'Contact person';
    }
    if (keyName === 'contactPhoneNumber') {
      return 'Phone';
    }
    // if (keyName === 'contractorTaxId') {
    //   return 'Federal Tax ID';
    // }
    if (keyName === 'contractorName') {
      return 'Contractor business name';
    }
    if (keyName === 'contractorEmail') {
      return 'Email';
    }
    if (keyName === 'contractorPhoneNumber') {
      return 'Phone';
    }
    return getDetailsLabel(keyName);
  };
  const getContractorDetailsHeading = () => {
    const { isContractor } = values;
    const { usingContractor } = details;
    let contractorDetailsHeading = '';
    if (isContractor) {
      contractorDetailsHeading = REVIEW.CONTRACTOR_COMPANY_DETAILS_HEADING;
    } else if (usingContractor.value === 'yes') {
      contractorDetailsHeading = REVIEW.NON_CONTRACTOR_COMPANY_DETAILS_HEADING;
    }
    return contractorDetailsHeading;
  };

// const formatTags = (tags) => {
//   if (!Array.isArray(tags) || !tags.length) return '';
//   return tags.map((tag) => tag.replace(/-/g, ' ')
//   .replace(/^[a-z]/, (letter) => letter.toUpperCase())
//     ).join(', ');
// };
  (function generateDetailsItems() {
    Object.keys(details).forEach((keyName) => {
      if (isContractor) {
        switch (keyName) {
          case 'contractorEmail':
          case 'usingContractor':
            return;
        }
      }
      const item = (
        <><Grid key={keyName} style={cardContentStyle} container direction="row">
          <Grid item xs={5} zeroMinWidth style={styleForLabel}>
            {getLabel(keyName)}
          </Grid>
          <Grid item xs={7} zeroMinWidth style={styleForValues}>
            {`${getDetailsValue(keyName)}`}
          </Grid>

        </Grid><hr style={styleForSeparator} /></>
       
      );
      if (!isContractorField(keyName)) {
        keyName !== 'usingContractor' && generalDetailsItems.push(item);
      } else {
        contractorDetailsItems.push(item);
      }
    });
  }());

  return (
    <Box style={{ padding: '20px' }}>
      <Heading type='h1-light' style={windowWidth < 600 ? {  marginBottom: '32px' } :
      { marginBottom: '32px' }} >
        {REVIEW.HEADING}
      </Heading>
      <div>
        <Heading type='h3-light' style= {{ marginBottom: '16px' }}>
          {REVIEW.COMPANY_HEADING}
        </Heading>
        {generalDetailsItems}
        {requireContractorDetails && (
          <Grid>
            <Heading type='h3-light' style={styleHeading}>{getContractorDetailsHeading()}</Heading>
            {contractorDetailsItems}
          </Grid>
        )}
      </div>

      {/* <Heading type='h3-light' style={styleHeading}>
        {REVIEW.SUPPLEMENT_HEADING}
      </Heading>
      <Grid container style={cardContentStyle} direction="row">

        <Grid item xs={5} zeroMinWidth style={styleForLabel}>
          <strong>{`${'Description'}`}</strong>
        </Grid>
        <Grid item xs={7} zeroMinWidth style={styleForValues}>
          {values.reason.freeText}
        </Grid>
        </Grid>

        <hr style={styleForSeparator} />
        <Grid container style={cardContentStyle} direction="row">

        <Grid item xs={5} style={styleForLabel} zeroMinWidth>
          <strong>{`${' Upload tags'}`}</strong>
        </Grid>
        <Grid item xs={7} zeroMinWidth style={styleForValues}>
          {formatTags(values.reason.tags)}
        </Grid>
        </Grid>
        <hr style={styleForSeparator} /> */}

      <Heading type='h3-light' style={styleHeading}>
        {REVIEW.ESTIMATE_HEADING}
      </Heading>
      <Table spacing="compact">
        {(filterFilesByEstimate.length > 0 && filterFilesByEstimate.map((file, index) => (
          <>
            <TableRow key={index} 
            style={{ display: 'flex', height:  windowWidth < 600 ? '200px' : '150px', maxWidth: '665px', 
            paddingTop: '15px', flexDirection: windowWidth < 600 ? 'column' : 'row' }}>
              <TableCell style={{  width: windowWidth < 600 ? '100%' : '50%' }}>

                <ThumbnailsGrid file={file} />
              </TableCell>
              <TableCell style={{ width: windowWidth < 600 ? '100%' : '50%', marginTop: windowWidth < 600 ? '72px' : '50px',
              marginBottom: windowWidth < 600 ? '16px' : '16px',
               justifyContent: windowWidth < 600 ? 'left' : 'right', flex: 1, display: 'flex', 
              textAlign: windowWidth < 600 ? 'left' : 'right' }}>
                <div style={{ width:  windowWidth < 600 ? '100%' : '300px', wordWrap: 'break-word',
                    overflowWrap: 'break-word', lineHeight: '25.6px' }}>
                 {file.name.slice(2).trim().replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ')}</div>
              </TableCell>
            </TableRow>
            <hr style={styleForSeparator} />
          </>
        ))
        )}
      </Table>

      {(filterFilesByOther.length > 0 && <Heading type='h3-light'  style={styleHeading}>
        {REVIEW.DOCUMENTS_HEADING}
      </Heading>)}
      <Table spacing="compact" style={{ marginBottom: '32px' }}>
        <TableBody>
        {(filterFilesByOther.length > 0 && filterFilesByOther.map((file, index) => (
          <>
            <TableRow key={index} style={{ display: 'flex',height:'auto' , minHeight:  windowWidth < 600 ? '180px' : '150px', 
              maxWidth: '665px', paddingTop: '15px',flexDirection: windowWidth < 600 ? 'column' : 'row' }}>
              <TableCell style={{ width: windowWidth < 600 ? '100%' : '50%' }}>

                <ThumbnailsGrid file={file} />
              </TableCell>
              <TableCell style={{ width: windowWidth < 600 ? '100%' : '50%', 
              marginTop: windowWidth < 600 ? '72px' : '50px', justifyContent: windowWidth < 600 ? 'left' : 'right',
              flex: 1, display: 'flex',
              textAlign: windowWidth < 600 ? 'left' : 'right' }}>
                <div style={{ width:  windowWidth < 600 ? '100%' : '300px', 
                  overflowWrap: 'break-word', wordWrap: 'break-word', lineHeight: '25.6px' }}>
                  {file.name.slice(2).trim().replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ')}
                 </div>
              </TableCell>
            </TableRow>            
          </>
        ))
        )}
        </TableBody>
      </Table>
    </Box>
  );
};

export default Review;
